module.exports = __webpack_public_path__ + "dist/img/wms.a433053e.webp";